export default __webpack_public_path__ + "static/media/digital-brain-background.f6d520bc.svg";